import { useEffect, useRef } from 'react';

const useScrollAnimation = (options = { threshold: 0.1, once: false }) => {
    const elementRef = useRef(null);

    useEffect(() => {
        const currentElement = elementRef.current;
        if (!currentElement) return;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    if (options.once) {
                        observer.unobserve(entry.target);
                    }
                } else {
                    if (!options.once) {
                        // entry.target.classList.remove('is-visible'); // Optional: remove when out of view
                    }
                }
            });
        }, { threshold: options.threshold });

        observer.observe(currentElement);

        return () => {
            if (currentElement) {
                observer.unobserve(currentElement);
            }
        };
    }, [options.threshold, options.once]);

    return elementRef;
};

export default useScrollAnimation; 